export default __webpack_public_path__ + "static/media/3031.7c250293.jpg";